export default __webpack_public_path__ + "static/media/item_6.09c6fb47.png";